var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 10.4165C11.3809 10.4165 12.5002 9.29722 12.5002 7.9165C12.5002 6.53579 11.3809 5.4165 10.0002 5.4165C8.61945 5.4165 7.50016 6.53579 7.50016 7.9165C7.50016 9.29722 8.61945 10.4165 10.0002 10.4165Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 18.3332C11.6668 14.9998 16.6668 12.8484 16.6668 8.33317C16.6668 4.65127 13.6821 1.6665 10.0002 1.6665C6.31826 1.6665 3.3335 4.65127 3.3335 8.33317C3.3335 12.8484 8.3335 14.9998 10.0002 18.3332Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.3f81864496304bbca8d11414c70c1604.svg";
export { ForwardRef as ReactComponent };